import { useGetApiV1LocationStatesDropdown } from '@/shared/api/generated';

/**
 * Hook para as opções de Estado (dropdown) usadas no seletor do formulário de
 * Cidade. Envolve `GET /api/v1/location/states/dropdown`, que retorna
 * `{ key, value }[]` (key = id do estado, value = nome).
 */
export function useStateDropdown() {
  const query = useGetApiV1LocationStatesDropdown();

  return {
    options: query.data ?? [],
    isLoading: query.isLoading,
  } as const;
}
